<div class="page-layout simple fullwidth">

    <div class="center" style="height: 100%; overflow-y: auto;">
        <div fxLayout="row wrap">

            <!-- RESOURCE INFO -->
            <div class="about-content p-24" fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">
                <div class="profile-box info-box general" fxLayout="column">
                    <header class="accent">
                        <div class="title">{{ resource?.name }}</div>
                    </header>

                    <div class="content">
                        <div class="info-line">
                            <div class="title">{{'Serial number'|translate}}</div>
                            <div class="info">
                                {{ resource?.serialNumber || '-' }}
                            </div>
                        </div>

                        <div class="info-line">
                            <div class="title">{{'Device ID'|translate}}</div>
                            <div class="info">
                                {{ resource?.deviceId || '-' }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="resource?.type">
                            <div class="title">{{'Type'|translate}}</div>
                            <div class="info">
                                {{ resource.type.name }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="resource?.category">
                            <div class="title">{{'Category'|translate}}</div>
                            <div class="info">
                                {{ resource.category.name }}
                            </div>
                        </div>

                        <div class="info-line">
                            <div class="title">{{'Is active'|translate}}</div>
                            <div class="info">
                                <span *ngIf="resource?.isActive" style="color: green;">{{'Yes'|translate}}</span>
                                <span *ngIf="!resource?.isActive" style="color: gray;">{{'No'|translate}}</span>
                            </div>
                        </div>

                        <div class="info-line">
                            <div class="title">{{'Is registered'|translate}}</div>
                            <div class="info">
                                <span *ngIf="resource?.isRegistered" style="color: green;">{{'Yes'|translate}}</span>
                                <span *ngIf="!resource?.isRegistered" style="color: gray;">{{'No'|translate}}</span>
                            </div>
                        </div>

                        <div class="info-line" *ngIf="resource?.enableCalendar">
                            <div class="title">{{'Calendar priority'|translate}}</div>
                            <div class="info">
                                {{ resource?.calendarPriority || '-' }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="resource?.enableCalendar">
                            <div class="title">{{'Reservation time'|translate}}</div>
                            <div class="info">
                                {{ resource?.reservationTime ? (resource.reservationTime + ' min') : '-' }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="resource?.requiredCredits">
                            <div class="title">{{'Required credits'|translate}}</div>
                            <div class="info">
                                {{ resource.requiredCredits }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="resource?.description && resource.description.length>0">
                            <div class="title">{{'Description'|translate}}</div>
                            <div class="info">
                                {{ resource.description }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- TRAINING HISTORY -->
            <div class="about-content p-24" fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">
                <div class="profile-box info-box general" fxLayout="column">
                    <header class="accent" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="title">{{'Training History'|translate}}</div>
                        <button mat-icon-button (click)="openTrainingListModal()" matTooltip="{{'Open in Modal'|translate}}">
                            <mat-icon>open_in_new</mat-icon>
                        </button>
                    </header>

                    <div class="content">
                        <div *ngIf="trainingsLoading" class="spinner-container" fxLayout="row" fxLayoutAlign="center center" style="padding: 48px;">
                            <mat-spinner [diameter]="40"></mat-spinner>
                        </div>

                        <div *ngIf="!trainingsLoading && trainings.length === 0" class="empty-state p-24" fxLayout="row" fxLayoutAlign="center center">
                            <span>{{'No training sessions found'|translate}}</span>
                        </div>

                        <div *ngIf="!trainingsLoading && trainings.length > 0">
                            <table class="table table-hover" style="width: 100%;">
                                <thead>
                                <tr>
                                    <th>{{'Date'|translate}}</th>
                                    <th>{{'Customer'|translate}}</th>
                                    <th style="text-align: center;">{{'Distance'|translate}} (km)</th>
                                    <th style="text-align: center;">{{'Calories'|translate}}</th>
                                    <th>{{'Status'|translate}}</th>
                                    <th>{{'Actions'|translate}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let training of trainings" style="cursor: pointer;">
                                    <td>{{training.createdAt | date: 'd.MM.y H:mm':'UTC': 'pl'}}</td>
                                    <td>{{training.user ? (training.user.firstName + ' ' + training.user.lastName) : '-'}}</td>
                                    <td style="text-align: center;">{{training.metrics?.distance ? (training.metrics.distance / 100000 | number:'1.1-2') : '-'}}</td>
                                    <td style="text-align: center;">{{training.metrics?.calories ? (training.metrics.calories | number:'1.0-0') : '-'}}</td>
                                    <td>
                                        <span *ngIf="training.isActive" style="color: green;">{{'Active'|translate}}</span>
                                        <span *ngIf="!training.isActive" style="color: gray;">{{'Finished'|translate}}</span>
                                    </td>
                                    <td>
                                        <button mat-icon-button [routerLink]="['/training-details', training.id]" matTooltip="{{'View Details'|translate}}">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            <!-- / TRAINING HISTORY -->

        </div>

    </div>
</div>